import { useReducer, useState } from "react";
import ProductContext from "./productContext";
import {
  collection,
  addDoc,
  query,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  getDocs,
  where,
  limit,
  Timestamp,
  orderBy,
  getDoc,
} from "firebase/firestore";
import { db, storage } from "../firebaseConfig";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import { cartReducer } from "./Reducer";

const ProductState = (props) => {
  const productsInitial = [];

  const [products, setProducts] = useState(productsInitial);
  const [productTitle, setProductTitle] = useState(productsInitial);
  const [collectionProducts, setCollectionProducts] = useState(productsInitial);
  const [orders, setOrders] = useState([]);
  const [promocode, setPromoCode] = useState([]);
  const [percent, setPercent] = useState();

  // fetch Product
  const fetchAllProduct = async () => {
    const productRef = collection(db, "Products");
    const q = query(productRef);
    onSnapshot(q, (snapshot) => {
      const product = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(product);
    });
  };

  const fetchCollectionProduct = async () => {
    const productRef = collection(db, "Products");
    const q = query(productRef, limit(6));
    onSnapshot(q, (snapshot) => {
      const product = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCollectionProducts(product);
    });
  };

  //add product
  const addProduct = async (
    show,
    code,
    title,
    description,
    size,
    stock,
    price,
    specialprice,
    color,
    category,
    image
  ) => {
    const storageRef = ref(storage, `/Images/${image.name}`);
    uploadBytesResumable(storageRef, image).then(() => {
      getDownloadURL(storageRef).then((url) => {
        const productRef = collection(db, "Products");
        addDoc(productRef, {
          show: show,
          productcode: code,
          title: title,
          description: description,
          size: size,
          stock: stock,
          price: price,
          specialprice: specialprice,
          color: color,
          category: category,
          image: url,
        })
          .then(() => {})
          .catch((error) => {});
      });
    });
  };

  //edit product

  const editProduct = async (
    id,
    code,
    title,
    description,
    size,
    stock,
    price,
    specialprice,
    color,
    category,
    image,
    imageUrl
  ) => {
    const productRef = doc(db, "Products", id);

    if (image !== imageUrl) {
      const storageRef = ref(storage, imageUrl);
      const updatedStorageRef = ref(storage, `Images/${image.name}`);

      await deleteObject(storageRef)
        .then(() => {})
        .catch((error) => {});

      await uploadBytesResumable(updatedStorageRef, image).then(() => {
        getDownloadURL(updatedStorageRef).then((url) => {
          updateDoc(productRef, {
            productcode: code,
            title: title,
            description: description,
            size: size,
            stock: stock,
            price: price,
            specialprice: specialprice,
            category: category,
            color: color,
            image: url,
          })
            .then(() => {})
            .catch((error) => {});
        });
      });
    } else {
      updateDoc(productRef, {
        productcode: code,
        title: title,
        description: description,
        size: size,
        stock: stock,
        price: price,
        specialprice: specialprice,
        category: category,
        color: color,
      })
        .then(() => {})
        .catch((error) => {});
    }
  };

  //delete product

  const deleteProduct = async (id, imageUrl) => {
    try {
      await deleteDoc(doc(db, "Products", id));
      const storageRef = ref(storage, imageUrl);
      await deleteObject(storageRef)
        .then(() => {})
        .catch((error) => {});
    } catch (error) {}

    // setProducts(newProduct);
  };

  const fetchProduct = async () => {
    const q = query(collection(db, "Products"), where("show", "==", true));
    const querySnapshot = await getDocs(q);

    const products = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setProducts(products);
  };

  const fetchProductTitle = async (title) => {
    const q = query(collection(db, "Products"), where("title", "==", title));
    const querySnapshot = await getDocs(q);
    const products = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setProductTitle(products);
  };

  const uploadOrders = async (
    name,
    phoneNo,
    address,
    city,
    state,
    paymentId,
    orderId,
    product,
    totalPrice
  ) => {
    const orderRef = collection(db, "Orders");

    addDoc(orderRef, {
      name: name,
      phoneNo: phoneNo,
      address: address,
      city: city,
      state: state,
      paymentId: paymentId,
      orderId: orderId,
      product: product,
      amount: totalPrice,

      orderedAt: Timestamp.fromDate(new Date()),
      markAsRead : false
    });
  };

  const getOrders = () => {
    const ordersRef = collection(db, "Orders");
    const q = query(ordersRef, orderBy("orderedAt", "desc"));
    onSnapshot(q, (snapshot) => {
      const orders = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setOrders(orders);
    });
  };

  const handleStock = (id, qty, stock) => {
    const productRef = doc(db, "Products", id);
    updateDoc(productRef, {
      stock: stock - qty,
    })
      .then(() => {})
      .catch((error) => console.log(error));
  };

  const uploadPromoCode = async (code, percent) => {
    const promoCoderRef = collection(db, "PromoCode");
    await addDoc(promoCoderRef, {
      promocode: code,
      percent: Number(percent),
    });
  };

  const getPromoCode = () => {
    const promoCodeRef = collection(db, "PromoCode");
    const q = query(promoCodeRef);
    onSnapshot(q, (snapshot) => {
      const promocode = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPromoCode(promocode);
    });
  };

  const deletePromoCode = async (id) => {
    await deleteDoc(doc(db, "PromoCode", id));
  };

  const fetchPromoPercent = async (promocode) => {
    const q = query(
      collection(db, "PromoCode"),
      where("promocode", "==", promocode)
    );
    const querySnapshot = await getDocs(q);
    try {
      const percentvalue = querySnapshot.docs.map((doc) => doc.data().percent);

      setPercent(percentvalue[0]);
    } catch (error) {
      setPercent(undefined);
    }
  };

  const markAsRead = async (id) => {

    const ordersRef = doc(db, "Orders", id);
    await updateDoc(ordersRef, {
      markAsRead: true,
    })
      .then(() => {})
      .catch((error) => {});
  };


  const markAsUnRead = async (id) => {

    const ordersRef = doc(db, "Orders", id);
    await updateDoc(ordersRef, {
      markAsRead: false,
    })
      .then(() => {})
      .catch((error) => {});
  };

  const [state, dispatch] = useReducer(cartReducer, {
    products: products,
    cart: [],
  });


  

  return (
    <ProductContext.Provider
      value={{
        products,
        addProduct,
        editProduct,
        deleteProduct,
        fetchAllProduct,
        state,
        dispatch,
        fetchProduct,
        fetchProductTitle,
        productTitle,
        uploadOrders,
        orders,
        getOrders,
        collectionProducts,
        fetchCollectionProduct,
        handleStock,
        uploadPromoCode,
        getPromoCode,
        promocode,
        deletePromoCode,
        fetchPromoPercent,
        percent,
        markAsRead,
        markAsUnRead
      }}
    >
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductState;
